var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"w-100 mw-md-200px",attrs:{"value":_vm.sort,"items":_vm.sortMethods,"outlined":"","hide-details":""},on:{"input":(sort) => _vm.$router.push({ query: { ...this.$route.query, sort, page: 1 } })}})
}
var staticRenderFns = []

export { render, staticRenderFns }